(function () {
    'use strict';

    angular.module('PWAPoCApp').directive('routeStopRowButtonsDefault', routeStopRowButtonsDefault);

    routeStopRowButtonsDefault.$inject = [];

    function routeStopRowButtonsDefault() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/shared/directives/routeStopCard/route-stop-row-buttons-default.html',
            transclude: true,
            link: link
        };

        return directive;

        function link(scope, element, attrs) {
        }
    }
})();